/**
 * @generated SignedSource<<45b75bf1075ffdf1dcaf0c24f127b9c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileScreenEmployeeProfileImage_employee$data = {
  readonly id: string;
  readonly image: {
    readonly __typename: "Image";
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly " $fragmentType": "ProfileScreenEmployeeProfileImage_employee";
};
export type ProfileScreenEmployeeProfileImage_employee$key = {
  readonly " $data"?: ProfileScreenEmployeeProfileImage_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileScreenEmployeeProfileImage_employee">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileScreenEmployeeProfileImage_employee",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Image_image"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "type": "Image",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Employee",
  "abstractKey": null
};
})();

(node as any).hash = "7a53c4f092e09da17a60565191ecd19e";

export default node;
